import { ref } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import providers from "@/lib/api";

export default function useUserTags() {
  const { authUser } = useAuthUser();
  const userTags = ref<string[]>([]);
  const userContentTypes = ref<string[]>([]);

  const update = async (fields: any) => {
    if (!authUser.value) {
      throw new Error("There is no authorized user");
    }
    const data: { fields: any } = { fields };
    data.fields.userId = authUser.value.id;
    const result = await providers.QuestionaryInfoProvider.update({ data });
    userTags.value = (result.fields.tags as number[]).map(t => t.toString());
    userContentTypes.value = (result.fields.tagsContentType as number[]).map(t => t.toString());
  };

  const userTagsUpdateData = (tags: string[]) => {
    return update({ tags });
  };

  const userContentTypesUpdateData = (tagsContentType: string[]) => {
    return update({ tagsContentType });
  };

  const userTagsGetData = async () => {
    if (!authUser.value) {
      throw new Error("There is no authorized user");
    }
    const result = await providers.QuestionaryInfoProvider.find({ id: authUser.value.id });

    userTags.value = (result.fields.tags as number[]).map(t => t.toString());
    userContentTypes.value = (result.fields.tagsContentType as number[]).map(t => t.toString());
  };

  return { userTags, userContentTypes, userTagsUpdateData, userContentTypesUpdateData, userTagsGetData };
}
